// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25lwO","fullView":"styles_fullView__3AeCg"};